export default __webpack_public_path__ + "static/media/thum4.39d3262a.jpg";